<template>
    <header class="main-header">
        <!-- Logo -->
        <router-link
            :to="{path: '/'}"
            :style="{backgroundColor: logoFileTopHeaderBackgroundColor}"
            :class="{collapsed: burgerMenuAllowedAndClosed}"
            class="logo"
        >
            <!-- mini logo for sidebar mini 50x50 pixels -->
            <span
                v-if="!(burgerMenuAllowedAndClosed)"
                class="logo-mini"
            >
                <b>
                    <img
                        :src="logoFileTopHeader"
                        alt="User Image"
                    >
                </b>
            </span>
            <!-- logo for regular state and mobile devices -->
            <span
                v-if="!(burgerMenuAllowedAndClosed)"
                class="logo-lg"
            >
                <img
                    :src="logoFileTopHeader"
                    alt="User Image"
                >
                <b></b>
            </span>
        </router-link>
        <div
            v-show="burgerMenuAllowed"
            :class="{menuBoxCollapsed: burgerMenuClosed, burgerWithStatusHeader: !isOnline || needUpdate}"
            class="menu-box"
            @click="$store.dispatch('fundation/change_burger_menu_value', !burgerMenuClosed)">
            <div
                :class="{ burgerInnerRight: burgerMenuClosed, burgerInnerLeft: !burgerMenuClosed}"
                class="burger"
            ></div>
        </div>
        <!-- Header Navbar: style can be found in header.less -->
        <nav
            :class="{navbarExpanded: burgerMenuAllowedAndClosed}"
            class="navbar navbar-static-top"
        >
            <!-- Sidebar toggle button-->
<!--             <a href="#" class="sidebar-toggle" data-toggle="offcanvas" role="button">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </a> -->
            <div v-if="displayAppSearchBar" class="pull-left-search" >
                <form
                    id="header-search-element"
                    @submit.prevent="setSearchTerm">
                    <input
                        v-model="searchTerm"
                        :class="{'focused': searchFilled }"
                        class="devin-search"
                        type="search">
                </form>
            </div>
            <div class="navbar-custom-menu">
                <ul class="nav navbar-nav">
                    <li v-if="getDashboardTopRightExtraTemplate">
                        <v-runtime-template
                            :template="getDashboardTopRightExtraTemplate">
                        </v-runtime-template>
                    </li>
                    <li
                        v-if="allowLanguageSwitch"
                        class="language-dropdown-selector"
                    >
                        <el-dropdown
                            trigger="click"
                            @command="setNewLang"
                        >
                            <span>
                                <span>{{ getVerbose('header_language_button')}}</span>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="lang in languagesAvailable"
                                    :key="lang.verbose"
                                    :command="lang.value"
                                >
                                    {{ lang.verbose }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <li v-if="currentUser">
                        <router-link
                            :to="{ name: 'profile' }"
                            class="usermail">
                            {{ currentUser.verbose_name }}
                        </router-link>
                    </li>
                    <li>
                        <el-button
                            class="logout-button"
                            circle
                            @click="logout"
                        >
                            <i class="ti-power-off"></i>
                        </el-button>
                        <!-- <el-dropdown
                            class="header-dropdown-devin"
                            :hide-on-click="false">
                            <span class="el-dropdown-link">
                                <el-badge v-if="undismissedAlerts.length > 0" :value="undismissedAlerts.length" :max="99" class="item alert-badge">
                                </el-badge>
                                <el-button type="text" size="small">
                                    <i class="ti-alert" v-if="undismissedAlerts.length > 0"></i>
                                    <i class="ti-check" v-else></i>
                                </el-button>
                          </span>
                          <el-dropdown-menu
                            v-if="undismissedAlerts.length > 0"
                            slot="dropdown"
                            style="overflow-x: auto;"
                            class="dropdown-alerts">
                            <el-dropdown-item
                              v-for="alert in undismissedAlerts"
                              :key="alert.uid">
                                <alert :alert="alert"></alert>
                            </el-dropdown-item>
                          </el-dropdown-menu>
                          <el-dropdown-menu v-else
                            slot="dropdown"
                            style="overflow-x: auto;"
                            class="dropdown-alerts">
                                <el-dropdown-item>
                                    No alert
                                </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown> -->
                    </li>
                </ul>
            </div>
        </nav>
    </header>
</template>
<script>
import Alert from './Alert.vue';
import VRuntimeTemplate from 'v-runtime-template';
import { mapGetters } from 'vuex';

export default {
    name: 'DashboardHeader',
    components: {
        Alert,
        VRuntimeTemplate,
    },
    data() {
        return {
            searchTerm: '',
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'isOnline',
            'needUpdate',
            'topBarIsRendered',
            'burgerMenuAllowed',
            'burgerMenuClosed',
            'burgerMenuAllowedAndClosed',
            'logoFileTopHeader',
            'getDashboardTopRightExtraTemplate',
            'logoFileTopHeaderBackgroundColor',
            'allowLanguageSwitch',
            'getVerbose',
            'languagesAvailable',
            'displayAppSearchBar',
        ]),
        ...mapGetters([
            'currentUser',
        ]),
        // computed not used QAM - 30/07/2019
        // statusChange () {
        //     return !this.isOnline  || this.needUpdate;
        // },
        // stateForSmoothTransition (){
        //     if (!this.isOnline) {
        //         return 'offline';
        //     }
        //     else if(this.needUpdate){
        //         return 'need_update';
        //     }
        //     return '';
        // },
        // alertText (){
        //     if (!this.isOnline) {
        //         return 'OFFLINE : Unable to connect to the server, please check your internet connectivity';
        //     }
        //     else if(this.needUpdate){
        //         return 'An update is available, please refresh the web page or <u class="link" onclick="window.location.reload()">click here</u>';
        //     }
        //     return ''
        // },
        searchFilled() {
            return this.searchTerm.length ? true : false;
        },
        // computed used in disabled template QAM - 30/07/2019
        // undismissedAlerts() {
        //     return this.$store.getters.alerts.filter(o => {
        //         return o.acquited == false;
        //     });
        // },
    },
    methods: {
        setNewLang(lang) {
            this.$store.dispatch('fundation/changeLang', lang);
        },
        // method not used QAM - 30/07/2019

        // dismiss(alert) {
        //     this.$store.dispatch('patchItem', {
        //         item: {
        //             uid: alert.uid,
        //             acquited: true,
        //             url: alert.url
        //         },
        //         model: 'alerts',
        //     });
        // },
        setSearchTerm() {
            this.$store.commit('SET_SEARCHTERM', this.searchTerm);
            this.$router.push({
                name: 'search'
            });
            this.searchTerm = '';
        },
        logout(){
            this.$store.dispatch('logoutUser');
        },
    }
};
</script>

<style lang="scss">
.main-header.headerMoving {
    top: 32px;
}
.main-header{
    position: fixed;
    overflow: hidden;
    transition: 1s top;
    .invisible{
        visibility: hidden;
    }

    .statusInfo {
        margin-bottom: 0;
        text-align: center;
        margin: -32px 0 0 0;
        font-weight: 600;
        padding: 6px 0;
        webkit-transition: 1s margin-top;
        transition: 1s margin-top;
        color: white;
        min-height: 32px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .notConnected {
        background-color: #EE3224;
    }
    .needUpdate {
        background-color: #409EFF;
    }
    .link {
        cursor: pointer;
    }
    .notConnected {
        background-color: #EE3224;
    }
    .needUpdate {
        background-color: #409EFF;
        .link {
            cursor: pointer;
        }
    }
    .moving {
        margin-top: 0;
    }
    .dropdown-alerts {
        .el-dropdown-menu__item:not(.is-disabled):hover {
            background: white;
        }
        li:last-of-type {
            border-bottom: 1px solid #fff;
        }
        li {
            display: block;
            width: 250px;
            border-bottom: 1px solid #ccc;
            line-height: 20px;
            padding: 10px 15px;
            transition: all .2s ease-in-out;
            &:last-of-type {
                border-bottom: 1px solid #fff;
            }
            &:hover {
                background: #3c8dbc;
                color: white;
            }
            .dismiss {
                padding-top: 10px;
                text-align: right;
                span {
                    display: inline-block;
                    background: #3c8dbc;
                    line-height: 20px;
                    padding: 0 10px;
                    border-radius: 10px;
                    color: white;
                    font-size: 12px;
                }
            }
        }
    }
    a.usermail {
        padding: 3px 20px !important;
        line-height: 30px !important;
        border: 1px solid #ccc;
        border-radius: 20px;
        margin-right: 10px;
        color: #999 !important;
        transition: all .2s ease-in-out;
        &:hover {
            border-color: #3c8dbc;
            color: #3c8dbc !important;
        }
        &.router-link-exact-active {
            color: #999 !important;
            border-color: #ccc;
            &:hover {
                color: #999 !important;
                border-color: #ccc;
                background: none;
            }
        }
    }

    .alert-badge{
        position: absolute;
        left: 25px;
    }

    .logout-button {
        border: 1px solid #ccc;
        border-radius: 20px;
        margin-right: 10px;
        color: #999 !important;
        transition: all .2s ease-in-out;
        &:hover {
            border-color: #3c8dbc;
            background-color: #fff;
            color: #3c8dbc !important;
        }
    }
    .menu-box {
        position: absolute;
        top: 20px;
        right: 10px;
        width: 40px;
        cursor: pointer;
        height: 24px;
        transition: .4s left, 1s top, .4s right;
        @media (min-width: 420px) {
            right: unset;
            left: 180px;
        }
    }
    .burger, .burger:after, .burger:before {
        position: absolute;
        width: 20px;
        height: 2px;
        transition: .15s transform;
        border-radius: 4px;
        background-color: #fff;
    }
    .burgerWithStatusHeader {
        top: 52px;
    }
    .burgerInnerRight {
        top: calc(50% - 1px);
        left: 10px;
    }
    .burgerInnerRight:before {
        margin-top: -5px;
        content: "";
    }
    .burgerInnerRight:after {
        margin-top: 5px;
        content: "";
    }
    .burgerInnerRight {
        top: calc(50% - 1px);
        left: 10px;
    }
    .burgerInnerLeft {
        top: calc(50% - 1px);
        left: 10px;
        visibility: hidden;
    }
    .burgerInnerLeft:before {
        margin-top: -5px;
        content: "";
        visibility: visible;
        transform: translate3d(4px,0.5px,0) rotate(-45deg) scaleX(.7);
    }
    .burgerInnerLeft:after {
        content: "";
        margin-top: 5px;
        transform: translate3d(4px,-0.5px,0) rotate(45deg) scaleX(.7);
        visibility: visible;
    }
    .menu-box:hover {
        .burgerInnerRight:before {
            transform: translate3d(4px,0.5px,0) rotate(45deg) scaleX(.7);
            visibility: visible;
        }
        .burgerInnerRight {
            visibility: hidden;
        }
        .burgerInnerRight:after {
            transform: translate3d(4px,-0.5px,0) rotate(-45deg) scaleX(.7);
            visibility: visible;
        }
    }
    .logo {
    }
    .collapsed {
        width: 60px !important;
    }
    .menuBoxCollapsed {
        right: calc(100vw - 50px);
        @media (min-width: 420px) {
            left: 10px;
            right: unset;
        }
    }
    .navbarExpanded {
        margin-left: 60px !important;
    }
    .navbar-nav {
        display: flex;
        align-items: center;
        margin-top: 12px;
        .language-dropdown-selector {
            margin-right: 10px;
            .el-dropdown {
                padding: 8px 20px;
                border: 1px solid #ccc;
                border-radius: 20px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/layouts/dashboard/Header.vue